import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Phone } from "@phosphor-icons/react";

const FAQ = ({ items, loading }) => {
  if (loading) {
    return (
      <section id="faq" className="py-24 sm:py-32 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="animate-pulse space-y-4">
            <div className="h-8 bg-slate-200 w-48" />
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-16 bg-slate-200" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      id="faq"
      className="py-24 sm:py-32 bg-slate-50"
      data-testid="faq-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left Content */}
          <div className="lg:col-span-4">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#0B2F6B]">
              FAQ
            </span>
            <h2 className="mt-4 text-3xl sm:text-4xl tracking-tight font-bold text-[#1A1A2E]">
              Frequently Asked Questions
            </h2>
            <p className="mt-4 text-lg text-slate-600">
              Find answers to common questions about our laser repair services.
              Can't find what you're looking for? Give us a call.
            </p>

            <div className="mt-8">
              <a href="tel:+18016479206">
                <Button className="bg-[#0B2F6B] hover:bg-[#0d3d8a] text-white rounded-none px-6 py-6">
                  <Phone weight="fill" className="w-5 h-5 mr-2" />
                  (801) 647-9206
                </Button>
              </a>
            </div>
          </div>

          {/* Right - Accordion */}
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="space-y-4">
              {items.map((faq, index) => (
                <AccordionItem
                  key={faq.id}
                  value={faq.id}
                  className="faq-item bg-white border border-slate-200 px-6 data-[state=open]:border-[#0B2F6B]"
                  data-testid={`faq-item-${index}`}
                >
                  <AccordionTrigger className="py-5 text-left font-semibold text-[#1A1A2E] hover:no-underline hover:text-[#0B2F6B] [&[data-state=open]]:text-[#0B2F6B]">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-slate-600 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
